export default __webpack_public_path__ + "static/media/portfolio.964af10a.svg";